export default __webpack_public_path__ + "static/media/spirals-no-3.8c956279.mid";